/**
 * @flow weak
 */

// Raw Selector
export const showCancelOrder = (state) => state.modal.showCancelOrderModal;
export const showEventDisclosure = (state) => state.modal && state.modal.showEventDisclosureModal;
export const showTicketTransfer = (state) => state.modal.showTransferTicketModal;
export const showCancelTicketTransfer = (state) => state.modal.showCancelTransferTicketModal;
export const showTicketTransferDisabled = (state) => state.modal.showTransferTicketDisabledModal;
export const showResendTicketTransfer = (state) => state.modal.showResendTransferTicketModal;
export const showRefund = (state) => state.modal.showRefundModal;
export const showEditGuestInfo = (state) => state.modal.showGuestInfoModal;
export const showEditBuyerInfo = (state) => state.modal.showBuyerInfoModal;
export const showPayInstallment = (state) => state.modal.showPayInstallmentModal;
export const showPayRemainingInstallments = (state) => state.modal.showPayRemainingInstallmentsModal;
export const showGenerateInvoiceConfirmation = (state) => state.modal.showGenerateInvoiceConfirmationModal;



// WEBPACK FOOTER //
// ./src/modules/modal/getters.js